// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_994fcfd8","outerContainer":"e911c98c","secondaryToolbar":"_2bae47aa","doorHangerRight":"_54963646","toolbarContainer":"a682d800","toolbarViewerMiddle":"b32e779d","progressBar":"d38f74b9","back-to-application":"_7f7e3482","root":"_3c34ae78","overlay":"_37018d4f","actions":"_41c2ea6f","patient":"c3376136","pinned":"_60c20ffc","btn":"_259ea573","controls":"_47afa31f","btnClose":"a995e62d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/SubscriberBtns/styles.styl
// module id = 1510
// module chunks = 39